module.exports = __webpack_public_path__ + "img/liangguangmochoubiandai.min.65bea5ee.png";